/*global kakao*/
import React, { Component } from 'react';
import { dashboardService } from '../../services';

class MapContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            map: "",
            mapLevel: 8,
            siteList: [],       // 현장 목록
            markerList: [],     // 마커 목록

            // 지사별 중심좌표정보
            officeCenter: [
                { damdangOffice: "DF001", lat: 37.57531, lng: 127.00072 },  // 주차서비스팀
                { damdangOffice: "DF002", lat: 37.57946, lng: 126.98623 },  // 강북지사(서비스)
                { damdangOffice: "DF003", lat: 37.51700, lng: 126.72410 },  // 인천지사(서비스)
                { damdangOffice: "DF004", lat: 37.57946, lng: 126.98623 },  // 강서지사(서비스)
                { damdangOffice: "DF005", lat: 37.50839, lng: 127.10476 },  // 강남지사(서비스)
                { damdangOffice: "DF006", lat: 37.31593, lng: 127.95971 },  // 강원지사(서비스)
                { damdangOffice: "DF007", lat: 37.50839, lng: 127.10476 },  // 분당지사(서비스)
                { damdangOffice: "DF008", lat: 37.50839, lng: 127.10476 },  // 수원지사(서비스)
                { damdangOffice: "DF009", lat: 35.13822, lng: 129.10107 },  // 부산지사(서비스)
                { damdangOffice: "DF010", lat: 35.86899, lng: 128.62676 },  // 대구지사(서비스)
                { damdangOffice: "DF011", lat: 35.53582, lng: 129.31347 },  // 울산지사(서비스)
                { damdangOffice: "DF012", lat: 35.22921, lng: 128.58502 },  // 경남지사(서비스)
                { damdangOffice: "DF013", lat: 35.16095, lng: 126.88598 },  // 광주지사(서비스)
                { damdangOffice: "DF014", lat: 36.32888, lng: 127.40413 },  // 대전지사(서비스)
                { damdangOffice: "DF015", lat: 35.81701, lng: 127.10548 },  // 전주지사(서비스)
                { damdangOffice: "DF016", lat: 33.48999, lng: 126.49562 },  // 제주지사(서비스)
                { damdangOffice: "DF017", lat: 35.16095, lng: 126.88598 },  // 충청지사(서비스)
                { damdangOffice: "DF018", lat: 37.57531, lng: 127.00072 },  // 서비스자재팀
                { damdangOffice: "DF019", lat: 37.57531, lng: 127.00072 },  // Major지사(서비스)
                { damdangOffice: "DF020", lat: 37.57531, lng: 127.00072 },  // Metro지사(서비스)
                { damdangOffice: "DF021", lat: 37.57531, lng: 127.00072 },  // 리모델링2팀
                { damdangOffice: "DF022", lat: 37.25055, lng: 127.48222 },  // 테스트지사
            ]
        }
    }


    // 지도 api를 호출
    componentDidMount() {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://dapi.kakao.com/v2/maps/sdk.js?appkey=43a8a1605dc713e5e1fc6329adcb7419&autoload=false&libraries=services";
        document.head.appendChild(script);

        script.onload = () => {
            kakao.maps.load(() => {
                this.createMap();
                this.setSiteList(this.props.selectedOffice.damdangOffice);
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.map && prevProps.selectedOffice !== this.props.selectedOffice) {
            this.deleteMarker(this.props.selectedOffice.damdangOffice);
            this.moveCenter(this.props.selectedOffice.damdangOffice);
        }
    }


    // 지도 생성 함수
    createMap = () => {
        const { mapLevel } = this.state;
        const container = document.getElementById("Mymap");
        const options = {
            center: new kakao.maps.LatLng(37.57531, 127.00072),   // 지도의 중심좌표
            level: mapLevel,                                    // 지도의 레벨(확대, 축소 정도)
        };

        // 지도 생성
        const map = new window.kakao.maps.Map(container, options);

        this.setState({
            map: map
        });

        // 지도 컨트롤러 생성
        const zoomControl = new kakao.maps.ZoomControl();
        map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

        kakao.maps.event.addListener(map, 'zoom_changed', function () {
            setMapLevel(map.getLevel());
        });

        const setMapLevel = (mapLevel) => {
            this.setState({
                mapLevel: mapLevel
            });
        }
    };

    // 지도 중심 이동
    moveCenter = (damdangOffice) => {
        const { map, officeCenter } = this.state;
        // 지도 중심 죄표 조회
        let lat = 37.2505520;
        let lng = 127.4822258;
        officeCenter.forEach(office => {
            if (office.damdangOffice === damdangOffice) {
                lat = office.lat;
                lng = office.lng;
            }
        });

        const moveLatLon = new kakao.maps.LatLng(lat, lng);

        // 지도 중심을 이동 시킵니다
        map.setCenter(moveLatLon)
        map.setLevel(8);
    };

    // 커스텀오버레이 or 마커 생성 함수
    createMarker = (siteList, map = this.state.map) => {
        let markerList = [];
        if (siteList && siteList.length > 0) {
            siteList.forEach((siteInfo) => {
                // 커스텀오버레이 엘리먼트 생성 및 컨텐츠 추가
                const content = document.createElement('div');
                content.className = 'overlay';
                content.innerHTML = siteInfo.content;

                // 커스텀오버레이 or 마커 생성
                let marker = "";
                marker = new kakao.maps.CustomOverlay({
                    map: map,                                                       // 커스텀오버레이가 표시될 지도
                    position: new kakao.maps.LatLng(siteInfo.lat, siteInfo.lng),    // 커스텀오버레이가 표시될 위치
                    content: content,                                               // 커스텀오버레이 내용
                });

                // 커스텀오버레이 엘리먼트 or 마커에 mouseover, mouseout, click 이벤트리스너 등록
                content.addEventListener('mouseover', () => this.handleMarkerMouseOver(marker));
                content.addEventListener('mouseout', () => this.handleMarkerMouseOut(marker));
                content.addEventListener('click', () => this.handleMarkerClick(siteInfo));

                // 커스텀오버레이 or 마커 목록 생성
                markerList.push(marker);
            });
        }

        this.setState({
            markerList: markerList
        });
    };

    // 마커 마우스오버 이벤트
    handleMarkerMouseOver = (marker) => {
        marker.setZIndex(2);
    };

    // 마커 마우스아웃 이벤트
    handleMarkerMouseOut = (marker) => {
        marker.setZIndex(0);
    };

    // 마커 클릭 이벤트
    handleMarkerClick = (siteInfo) => {
        const { siteID } = siteInfo;
        this.props.handleSelectedSiteID(siteID);
    };

    // 마커 삭제
    deleteMarker = (damdangOffice) => {
        const { markerList } = this.state;
        markerList.map(marker => marker.setMap(null));

        this.setState({ markerList: [] });
        this.setSiteList(damdangOffice);
    };

    // 현장 목록 호출
    setSiteList = (damdangOffice) => {
        let markerdataList = [];

        if (damdangOffice) {
            let formData = new FormData();
            formData.append("damdangOffice", damdangOffice);

            dashboardService.opbMapMarkerList(formData)
                .then(response => {
                    for (let index = 0; index < response.data.length; index++) {
                        let markerdata = response.data[index];
                        const title = markerdata.siteName;
                        const content = this.setOfficeContent(title);

                        markerdata = {
                            ...markerdata,
                            title,
                            content,
                            lat: markerdata.ltu,
                            lng: markerdata.lnt,
                        };
                        markerdataList.push(markerdata);
                    }

                    this.setState({
                        siteList: markerdataList
                    });

                    this.createMarker(markerdataList);
                })
                .catch(this.handleError);
        }

        return markerdataList;
    };

    // 인포윈도우 컨텐츠 설정
    setOfficeContent = (title) => {
        return (
            "<div class='' style='font-size: 12px; width: max-content; cursor: pointer; background: white; border: 1px solid blue; border-radius: 8px; padding: 5px;'>" +
            "<img class='ic-refresh' src='/assets/images/dashboard/ic_contract.svg' alt='지도마커' />" + title +
            "</div>");
    };

    render() {
        return (
            <>
                <div id="Mymap" className="dashboard-mapcontents"></div>
            </>
        );
    }
}

export default MapContent;